import React, { useRef, useState, useEffect } from 'react';
import './darshan.scss'
import { Box, Container, Grid, Link } from '@mui/material';
import SEO from '../../seo/SEO';
function VrDarshanNew() {

const steps = [
    {
      id: "01",
      icon: "fa fa-mobile",
      title: "STEP ",
      description:
        "Open the Mandirwiki app and select the video you would like to watch.",
    },
    {
      id: "02",
      icon: "fa fa-mobile",
      title: "STEP",
      description:
        "Place your phone inside the VR headset.",
    },
    {
      id: "03",
      icon: "fa fa-headphones",
      title: "STEP",
      description:
        "If the image appears blurry, use the adjustment wheel on the VR headset to adjust the lenses until the view is clear.",
    },
  ];  
const featuredExperiences = [
  {
    image: "/assets/banner/vr-darshan/temples/dwarka-beneth.webp",
    title: "Dwarka Beneath the Sea",
    location: "GUJRAT, INDIA",
    duration: "3 MIN",
    // views: "1.2 M",
    badge: "LIVE RITUALS",
    link: "/vr-darshan/ganga-aarti",
    fullWidth: true,
    description:
      "The Lost Kingdom of Krishna | 360° VR",
  },
  {
    image: "/assets/banner/vr-darshan/temples/varanashi.webp",
    title: "Varanasi After Sunset",
    location: "VARANASI, INDIA",
    duration: "9 MIN",
    // views: "850 K",
    badge: "LIVE RITUALS",
    link: "/vr-darshan/vaishno-devi",
    description:
      "The Grand Ganga Aarti of Kashi | 360° VR",
  },
  {
    image: "/assets/banner/vr-darshan/temples/kashi.webp",
    title: "Kashi",
    location: "VARANASI, INDIA",
    duration: "9 MIN",
    // views: "850 K",
    badge: "LIVE RITUALS",
    link: "/vr-darshan/vaishno-devi",
    description:
      "Along the Eternal Ghats of the Ganges | 360° VR",
  },
  {
    image: "/assets/banner/vr-darshan/temples/manikarna.webp",
    title: "Manikarnika",
    location: "VARANASI, INDIA",
    duration: "9 MIN",
    // views: "950 K",
    badge: "LIVE RITUALS",
    link: "/vr-darshan/kedarnath",
    description:
      "The Gateway to Moksha | 360° VR",
  },
  {
    image: "/assets/banner/vr-darshan/temples/krishan.webp",
    title: "The Last Moments of Lord Krishna",
    location: "GUJRAT, INDIA",
    duration: "9 MIN",
    // views: "850 K",
    badge: "LIVE RITUALS",
    link: "/vr-darshan/vaishno-devi",
    description:
      "The Arrow That Changed an Age | VR Experience",
  },
  {
    image: "/assets/banner/vr-darshan/temples/jagannath.webp",
    title: "Jagannath Puri TEMPLE",
    location: "Odisha, INDIA",
    duration: "9 MIN",
    // views: "950 K",
    badge: "LIVE RITUALS",
    link: "/vr-darshan/kedarnath",
    description:
      "Secrets of the Divine Temple | VR Experience",
  },
  {
    image: "/assets/banner/vr-darshan/temples/kedarnath.webp",
    title: "KEDARNATH TEMPLE",
    location: "JAMMU, INDIA",
    duration: "9 MIN",
    // views: "850 K",
    badge: "LIVE RITUALS",
    link: "/vr-darshan/vaishno-devi",
    description:
      "When Shiva Hid from the Pandavas | VR Experience",
  },
  {
    image: "/assets/banner/vr-darshan/temples/bhim-shila.webp",
    title: "Bhim Shila TEMPLE",
    location: "UTTARAKHAND, INDIA",
    duration: "9 MIN",
    // views: "950 K",
    badge: "LIVE RITUALS",
    link: "/vr-darshan/kedarnath",
    description:
      "The Rock That Saved Kedarnath | VR Experience",
  },
  {
    image: "/assets/banner/vr-darshan/temples/deoghar.webp",
    title: "Deoghar",
    location: "Jharkhand, INDIA",
    duration: "9 MIN",
    // views: "850 K",
    badge: "LIVE RITUALS",
    link: "/vr-darshan/vaishno-devi",
    description:
      "When Ravana Tried to Take Shiva Home | VR Experience",
  },
  {
    image: "/assets/banner/vr-darshan/temples/vaishno-devi.webp",
    title: "Vaishno Devi TEMPLE",
    location: "UTTARAKHAND, INDIA",
    duration: "9 MIN",
    // views: "950 K",
    badge: "LIVE RITUALS",
    link: "/vr-darshan/kedarnath",
    description:
      "The Day the Goddess Revealed Her True Form | VR Experience",
  },
  
  
];

const [visibleCards, setVisibleCards] = useState(10);

  const handleLoadMore = () => {
    setVisibleCards((prev) => prev + 10);
  };
return (
<>
<SEO pageKey="vrDarshanNew" />
<Box className="VrDarshanBanner" >
   <Container maxWidth="lg">
      <Grid container spacing={2} justifyContent="left" alignItems="center">
         <Grid size={{ xl: 10, lg: 10, md: 12, sm: 12, xs: 12 }} >
         <Box className="VrBannerText">
            <span className="virtualTab">
            VIRTUAL DARSHAN
            </span>
            <div>
               <h1 className="mt-4">STEP INSIDE THE SCARED, IN 360</h1>
               <p>Cinematic 360 experience form temples across the subcontinent-drag, look around, and lose yourself in real sanctums from wherever you are.</p>
               <div className="d-flex gap-3 bannerButton">
                  {/* <Box className="text-center mt-3">
                     <button href="/listing" className="btn btn-success text-dark"><i className="fa fa-play me-1 text-dark"></i> Begin a Darshan</button>
                  </Box> */}
                  <Box className="text-center mt-3">
                     <a href="#threeSteps" className="btn btn-warning text-dark">How VR Works <i className="fa fa-arrow-right ms-1 text-dark"></i></a>
                  </Box>
               </div>
            </div>
         </Box>
      </Grid>
      </Grid>
   </Container>
</Box>
 <Box className="videoList mb-5">
      <Container maxWidth="lg">
        <Grid container spacing={2}>
          <Grid size={{ xs: 12 }}>
            <Box className="templeInnerHeading my-4">
              <span>Now Streaming</span>

              <h2 className="mt-1">
                Featured experiences
              </h2>

              <p>
                Hand-Crafted spherical panoramas with spatial audio.
                Tap any experience to enter the 360 viewer—
                works on phone, desktop and VR headset.
              </p>
            </Box>
          </Grid>

          {featuredExperiences
            .slice(0, visibleCards)
            .map((item, index) => (
             <Grid
  key={index}
  size={{
    xl: item.fullWidth ? 12 : 3,
    lg: item.fullWidth ? 12 : 3,
    md: item.fullWidth ? 12 : 4,
    sm: item.fullWidth ? 12 : 6, // 2 cards per row
    xs: 6, // 1 card per row on mobile
  }}
>
                {/* <Link
                  href={item.link}
                  className="card-link"
                > */}
                  <div className="ritual-card">
                    <img
                      src={item.image}
                      alt={item.title}
                      className="ritual-card-img"
                    />

                    <div className="card-overlay"></div>

                    <div className="live-badge">
                      {item.badge}
                    </div>

                    <button
                      className="play-btn"
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        console.log("Play Video");
                      }}
                    >
                      <i className="fa fa-play"></i>
                    </button>

                    <div className="card-content">
                      <div className="meta-info">
                        <div className="meta-item">
                          {item.location}
                        </div>

                        <span className="divider"></span>

                        <div className="meta-item">
                          <i className="fa fa-clock-o"></i>
                          {item.duration}
                        </div>

                        {/* <span className="divider"></span>

                        <div className="meta-item">
                          <i className="fa fa-eye"></i>
                          {item.views}
                        </div> */}
                      </div>

                      <h2>{item.title}</h2>

                      <p>{item.description}</p>
                    </div>
                  </div>
                {/* </Link> */}
              </Grid>
            ))}

          {/* Load More Button */}
          {visibleCards < featuredExperiences.length && (
            <Grid size={{ xs: 12 }}>
              <div className="text-center mt-4">
                <button
                  className="btn btn-warning"
                  onClick={handleLoadMore}
                >
                  Load More
                </button>
              </div>
            </Grid>
          )}
        </Grid>
      </Container>
    </Box>

<Box className="ritualStepsSection" id="threeSteps">
      <Container maxWidth="lg">
        <Grid container spacing={4} alignItems="center">

          <Grid size={{ xl: 5, lg: 5, md: 5, sm: 12, xs: 12 }}>
            <Box className="stepsLeft">

              <span className="subTitle">
                THE RITUAL
              </span>

              <h2>
                THREE STEPS TO
                <br />
                YOUR DARSHAN.
              </h2>

              <p>
                No headset? No problem. Each experience is built
                to be felt on any device, then deepened in full VR
                when you're ready.
              </p>

            </Box>
          </Grid>

          <Grid size={{ xl: 7, lg: 7, md: 7, sm: 12, xs: 12 }}>
            <Box className="stepsRight">

              {steps.map((item, index) => (
                <Box className="stepCard" key={index}>

                  <div className="iconBox">
                    <i className={item.icon}></i>
                  </div>

                  <div className="content">
                    <span>{item.id}</span>
                    <h4>{item.title}</h4>
                    <p>{item.description}</p>
                  </div>

                </Box>
              ))}

            </Box>
          </Grid>

        </Grid>
      </Container>
    </Box>
</>
);
}
export default VrDarshanNew;